import React, { useCallback, useState } from 'react';
import * as Yup from 'yup';
import GenericModalForm from '../../components/GenericModalForm';
import GenericTextArea from '../../components/GenericTextArea';
import GenericTextInput from '../../components/GenericTextInput';
import { ModalRef } from '../../hooks/useModalRef';
import styled from 'styled-components';
import GenericModal from '../../components/GenericModal';

import { FormikHelpers } from 'formik';
import { Question } from '../../models/Question';
import useQuestions from '../../services/swr/useQuestions';
import { stripEmptyFields } from '../../utils/objects';

interface ComponentProps {
  questionInfo: Question;
}

const EditQuestionModal = React.forwardRef(
  ({ questionInfo }: ComponentProps, ref) => {
    const { updateQuestion } = useQuestions();

    const [target, setTarget] = useState<string>(questionInfo.target);

    const onSubmit = useCallback(
      async (
        values: Record<string, unknown>,
        helpers: FormikHelpers<Record<string, unknown>>,
      ) => {
        let questionModel = {
          ...stripEmptyFields(values),
        };
        if (target !== questionInfo.target) {
          questionModel = {
            ...questionModel,
            target,
          };
        }

        await updateQuestion(questionInfo.id, questionModel);

        const { setSubmitting, resetForm } = helpers;

        setSubmitting(false);
        resetForm();

        (ref as ModalRef).current?.closeModal();
      },
      [questionInfo.id, ref, target],
    );

    const closeModal = useCallback(
      () => (ref as ModalRef).current?.closeModal(),
      [ref],
    );

    return (
      <ModalContainer ref={ref}>
        <GenericModalForm
          initialValues={{
            optionA: '',
            optionB: '',
            optionC: '',
            optionD: '',
            description: '',
            target: '',
          }}
          validationSchema={Yup.object().shape({
            optionA: Yup.string().optional(),
            optionB: Yup.string().optional(),
            optionC: Yup.string().optional(),
            optionD: Yup.string().optional(),
            target: Yup.string().optional(),
            description: Yup.string().optional(),
          })}
          submitButtonType="edit"
          onSubmit={onSubmit}
          onCancel={closeModal}
        >
          <GenericTextArea
            name="description"
            label="Descrição"
            placeholder={questionInfo.description}
          />
          <GenericTextInput
            name="optionA"
            label="A)"
            type="text"
            placeholder={questionInfo.optionA}
          />
          <GenericTextInput
            name="optionB"
            label="B)"
            type="text"
            placeholder={questionInfo.optionB}
          />
          <GenericTextInput
            name="optionC"
            label="C)"
            type="text"
            placeholder={questionInfo.optionC}
          />
          <GenericTextInput
            name="optionD"
            label="D)"
            type="text"
            placeholder={questionInfo.optionD}
          />
          <SelectContainer>
            <SelectLabel htmlFor="target">Resposta</SelectLabel>
            <SelectCourse
              name="course"
              value={target}
              onChange={e => setTarget(e.target.value)}
            >
              <option value="optionA">Alternativa A</option>
              <option value="optionB">Alternativa B</option>
              <option value="optionC">Alternativa C</option>
              <option value="optionD">Alternativa D</option>
            </SelectCourse>
          </SelectContainer>
        </GenericModalForm>
      </ModalContainer>
    );
  },
);

export const ModalContainer = styled(GenericModal)`
  width: 80%;
  max-width: 600px;
`;

export const SelectContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SelectLabel = styled.label`
  font-family: var(--font-sans);
  font-size: 1rem;
  color: var(--color-gray-800);
  margin-bottom: 0.5rem;
  font-weight: 500;
  display: block;
`;
export const SelectCourse = styled.select`
  width: 100%;
  padding: 0.625rem;
  border-radius: 10px;
  font-family: var(--font-sans);
  font-size: 1rem;
  color: var(--color-gray-800);
  background-color: var(--color-white);
  margin-bottom: 1rem;
`;

EditQuestionModal.displayName = 'EditQuestionModal';

export default EditQuestionModal;
